import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { closeCreateAndUpdateZoneForm } from "../../actions/campaign-planning/ZonesAndSubZonesActions";

// Constants
import { FormDataTargets } from "../../../constants/GeneralConstants";

// Page Functions
function checkIsFormDataFilled(formData) {
  return Object.values(formData).every(
    (value) => value !== null && value !== undefined && value !== ""
  );
}

/**
 * Form-Modal for CreateAndUpdateZoneForm
 */
export default function CreateAndUpdateZoneForm({ onSubmit = () => {} }) {
  const dispatch = useDispatch();

  // state
  const [formData, setFormData] = useState({
    name: "",
    district: "",
    state: "",
    bbox: "",
  });

  // data
  const zoneProcessDataObj = useSelector(
    (state) => state.zonesAndSubZones.zoneProcessDataObj
  );
  const { isUpdate = false, zone = {} } = zoneProcessDataObj || {};
  const createOrUpdateText = isUpdate ? "Update" : "Create";

  // check data filled
  const isFormFilled = checkIsFormDataFilled(formData);

  // input data
  const inputFields = [
    {
      displayTag: "Zone Name",
      placeholder: "Enter zone name",
      name: "name",
      value: formData.name,
    },
    {
      displayTag: "District Name",
      placeholder: "Enter district name",
      name: "district",
      value: formData.district,
    },
    {
      displayTag: "State Name",
      placeholder: "Enter state name",
      name: "state",
      value: formData.state,
    },
    {
      displayTag: "Bbox",
      placeholder: "Enter bbox",
      name: "bbox",
      value: formData.bbox,
    },
  ];

  // fill existing data
  useEffect(() => {
    setFormData({
      name: zone?.name || "",
      district: zone?.district || "",
      state: zone?.state || "",
      bbox: zone?.bbox || "",
    });
  }, [JSON.stringify(zone)]);

  // handle change
  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

  // Function
  function handleSubmitForm() {
    // add typeStr
    formData.typeStr = "ZONE";

    // callback fn
    onSubmit(isUpdate, formData, zone.id);

    // close
    dispatch(closeCreateAndUpdateZoneForm());
  }

  function handleCloseForm() {
    dispatch(closeCreateAndUpdateZoneForm());
  }

  return (
    <div
      className="modal fade"
      id={FormDataTargets.createAndUpdateZoneForm}
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          {/* Form Header */}
          <div className="modal-header bg-alt align-items-center px-5">
            <h4 className="modal-title">{`${createOrUpdateText} Zone`}</h4>

            {/* bbox documentation */}
            <a
              href="https://boundingbox.klokantech.com"
              target="_blank"
              rel="noreferrer"
              className="mt-1"
            >
              Bbox Documentation
            </a>
          </div>

          {/* Form body */}
          <div className="modal-body px-5">
            {inputFields.map((info, i) => {
              const { displayTag, placeholder, name, value } = info;
              return (
                <div key={i} className="form-group row">
                  <label className="col-2 col-form-label">{displayTag}</label>
                  <div className="col-10">
                    <input
                      type="search"
                      className={`form-control shadow-none rounded-lg`}
                      placeholder={placeholder}
                      name={name}
                      value={value}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          {/* Form Footer */}
          <div className="modal-footer px-5">
            <button
              type="button"
              className="btn btn-outline-primary btn-action mt-2 mr-3 shadow-none"
              data-dismiss="modal"
              onClick={handleCloseForm}
            >
              {"Close"}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-action mt-2 shadow-none"
              data-dismiss="modal"
              onClick={handleSubmitForm}
              disabled={!isFormFilled}
            >
              {createOrUpdateText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
